import { useQuery } from "@tanstack/react-query";

import { messagingApi } from "@/lib/messaging/messaging.api";

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Derniers événements de notifications pour le header (cloche) :
 * liste des envois récents + nombre d'échecs sur les dernières 24 h.
 */
export function useNotificationLogs(limit = 8) {
	const query = useQuery({
		queryKey: ["messaging", "logs", "recent"],
		queryFn: () => messagingApi.listLogs({ limit: 20 }),
		refetchInterval: 60_000,
		staleTime: 30_000,
		retry: false,
	});

	const items = query.data?.items ?? [];
	const failedCount = items.filter(
		(l) =>
			l.status === "failed" &&
			Date.now() - new Date(l.createdAt).getTime() < DAY_MS,
	).length;

	return {
		logs: items.slice(0, limit),
		failedCount,
		isLoading: query.isLoading,
		isError: query.isError,
	};
}
